<template>
  <div>
    <div v-if="loading" class="text-center text-danger my-2">
      <b-spinner class="align-middle"></b-spinner>
      <strong class="ml-2">{{ $t('LIST_LOADING_LABEL', {catalog: $t('TURNS')})  | capitalize}}</strong>
    </div>
    <b-select
        v-else
        id="turn-input" type="text"
        :state="state"
        :value="content"
        @change="handleInput" class="w-100">
      <b-select-option :value="undefined">{{$t(undefinedMeans, {gender: 'o', catalog: $t('TURNS')}) | capitalize}}</b-select-option>
      <b-select-option :key="item.id" v-for="item in items" :value="valueType === 'id' ? item.id : item._links.self.href">{{$t(item.name)}}</b-select-option>
    </b-select>
    <b-form-invalid-feedback id="turn-input-feedback">
      <div v-for="error in errors" :key="error.error">
        {{ $t('FORMS_ERROR_FIELD_' + error.error, {...error.params, ...{field: $t('TURN')},})  | capitalize }}
      </div>
    </b-form-invalid-feedback>
  </div>

</template>

<script>
import {VModel, SendsMessages} from "@/mixins";
import Turn from "@/turns/index";
import eventBus from "@/events";

export default {
  name: "TurnSingleSelector",
  props: ['state', 'errors', 'companyId','valueType', 'undefinedMeans'],
  mixins: [VModel, SendsMessages],
  methods: {
    async loadTurns(companyId) {
      try {
        this.loading = true;
        this.items = await Turn.findAll({perPage: 1000, sortBy: 'name', filter: {status: true, companyId: companyId || this.companyId}});
      } catch(e) {
        this.sendError('ERROR_LOADING_CATALOG', {}, e);
      } finally {
        this.loading = false;
      }
    },
    handleInput(val) {
      this.$emit('input', val);
      const test = this.items.find(item => item._links.self.href === val);
      this.$emit('instance', test);
    },
  },
  async mounted() {
    await this.loadTurns();
    const that = this;
    eventBus.$on('ROUTE_FORM_COMPANY_CHANGE', async function(companyId) {
      that.loadTurns(companyId);
    });

    eventBus.$on('TRAVEL_FORM_COMPANY_CHANGE', async function(companyId) {
      that.loadTurns(companyId);
    });
  },
  data() {
    return {
      loading: false,
      items: []
    }
  }
}
</script>

<style scoped>

</style>
